import { freightPickupAccessorialPresetIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const setDefaultFreightPickupAccessorialPreset = {
  name: "setDefaultFreightPickupAccessorialPreset" as const,
  input: z.object({ id: freightPickupAccessorialPresetIdFormat.schema }),
  output: z.object({}),
};
